import React from "react";
import { Button } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import ViewModuleIcon from "@material-ui/icons/ViewModule";

import BloqueEditor from "./bloque-editor";

export const bloqueVacio = (indice = 0) => ({
  nombre: `Bloque ${indice + 1}`,
  porcentaje: 0,
  fuente: "mas_leidos_cliente",
  institutoPlanLector: "",
  fechaInicio: "",
  fechaFin: "",
  condiciones: [],
});

export const BLOQUES_POR_DEFECTO = [
  {
    nombre: "Más leídos del cliente",
    porcentaje: 40,
    fuente: "mas_leidos_cliente",
    institutoPlanLector: "",
    fechaInicio: "",
    fechaFin: "",
    condiciones: [],
  },
  {
    nombre: "Más leídos global",
    porcentaje: 30,
    fuente: "mas_leidos_global",
    institutoPlanLector: "",
    fechaInicio: "",
    fechaFin: "",
    condiciones: [],
  },
  {
    nombre: "Novedades",
    porcentaje: 30,
    fuente: "novedades",
    institutoPlanLector: "",
    fechaInicio: "",
    fechaFin: "",
    condiciones: [],
  },
];

export const totalPorcentaje = (bloques = []) =>
  bloques.reduce((acc, bloque) => acc + (Number(bloque.porcentaje) || 0), 0);

/**
 * Los bloques con su porcentaje total. La generación se bloquea hasta que sume 100
 * porque el reparto de cuotas se calcula sobre ese total.
 */
const ListaBloques = ({ bloques = [], onChange, opcionesApi, cantidad = 0 }) => {
  const total = totalPorcentaje(bloques);
  const sumaCorrecta = Math.round(total) === 100;

  const handleBloque = (indice, bloque) => {
    const temp = [...bloques];
    temp[indice] = bloque;
    onChange(temp);
  };

  const handleRemove = (indice) => {
    onChange(bloques.filter((_, i) => i !== indice));
  };

  const handleMover = (indice, direccion) => {
    const destino = indice + direccion;
    if (destino < 0 || destino >= bloques.length) return;
    const temp = [...bloques];
    [temp[indice], temp[destino]] = [temp[destino], temp[indice]];
    onChange(temp);
  };

  return (
    <div>
      <div className="d-flex align-items-center">
        <ViewModuleIcon style={{ fontSize: "17px" }} />
        <div className="admin-main-title-dark-gray ml-2 mt-1">
          Bloques de recomendación
        </div>
      </div>
      <div className="admin-muted-text-small mt-1 mb-3">
        El orden define la prioridad: si un libro cae en dos bloques, se queda en el
        de más arriba.
      </div>

      {bloques.map((bloque, indice) => (
        <BloqueEditor
          key={indice}
          bloque={bloque}
          indice={indice}
          total={bloques.length}
          onChange={(nuevo) => handleBloque(indice, nuevo)}
          onRemove={() => handleRemove(indice)}
          onMover={(direccion) => handleMover(indice, direccion)}
          opcionesApi={opcionesApi}
          librosEstimados={
            cantidad > 0
              ? Math.round((cantidad * (Number(bloque.porcentaje) || 0)) / 100)
              : undefined
          }
        />
      ))}

      <div className="d-flex align-items-center justify-content-between">
        <Button
          size="small"
          startIcon={<AddIcon />}
          onClick={() => onChange([...bloques, bloqueVacio(bloques.length)])}
        >
          Agregar bloque
        </Button>
        <div
          className={`admin-muted-text-small ${sumaCorrecta ? "" : "text-danger"}`}
        >
          Total: {total}% {sumaCorrecta ? "" : "(debe sumar 100%)"}
        </div>
      </div>
    </div>
  );
};

export default ListaBloques;
